/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import React from "react"
import { isBlank, Spacer } from "@cd2/components"
import { IRecord } from "../types/schema"

export type IAddressRecord = IRecord<
  "addresses",
  | "name"
  | "contact"
  | "line_1"
  | "line_2"
  | "line_3"
  | "line_4"
  | "city"
  | "county"
  | "country"
  | "postcode"
  | "phone"
  | "email"
>

interface IAddressShow {
  heading?: string
  address?: Partial<IAddressRecord>
}

export function AddressDisplayPanel({ heading, address }: IAddressShow) {
  if (!address) {
    return null
  }

  const addressFields: (keyof IAddressRecord)[] = [
    "name",
    "contact",
    "line_1",
    "line_2",
    "line_3",
    "line_4",
    "city",
    "county",
    "country",
    "postcode",
    "email",
    "phone",
  ]

  return (
    <div
      css={css`
        border: 1px solid #ddd;
        background-color: white;
        max-width: 400px;
        padding: 12px;
      `}
    >
      {heading && (
        <React.Fragment>
          <b>{heading}</b>
          <Spacer size={14} />
        </React.Fragment>
      )}
      {addressFields.map((k, i) => (address[k]?.trim() ? <div key={i}>{address[k]}</div> : null))}
    </div>
  )
}

export function addressAsParagraph(address: IAddressRecord, omit?: (keyof IAddressRecord)[]) {
  return (
    <p
      css={css`
        margin: 0;
      `}
    >
      {addressAsArray(address, omit).map((el, i) => (
        <React.Fragment key={i}>
          {i !== 0 && <br />}
          {el}
        </React.Fragment>
      ))}
    </p>
  )
}

export function addressAsArray(address?: IAddressRecord, omit?: (keyof IAddressRecord)[]) {
  if (!address) {
    return []
  }
  const addressFields = (
    [
      "name",
      "contact",
      "line_1",
      "line_2",
      "line_3",
      "line_4",
      "city",
      "county",
      "country",
      "postcode",
      "email",
      "phone",
    ] as (keyof IAddressRecord)[]
  ).filter(el => !omit?.includes(el))

  return addressFields.filter(el => !isBlank(address[el])).map(el => address[el])
}
